var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-refresh btn--menu btn-reset"},[_c('span',{staticClass:"btn__icon-wrap"},[_c('span',{staticClass:"icon-refresh"},[_c('svgicon',{attrs:{"icon":"button/refresh","width":"19","height":"20"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }